module.exports = require("fast-deep-equal");